const DEFAULTS = {
  awsRegion: "us-east-1",
  cognitoUserPoolId: "us-east-1_w3wAwdoyT",
  cognitoAppClientId: "30fh2diavq2qhubfspcon26soc",
  apiGatewayStage: "Prod",
  conversationApiUrl:
    "https://tja4kkhok2.execute-api.us-east-1.amazonaws.com",
  transcribeJobPrefix: "PROD-",
  summarizeJobPrefix: "Summarize-PROD-",
  mobileAudioBucket: "knowtex-staging-audios-prod",
  mergedAudioBucket: "knowtex-merged-audio-prod",
  realtimeAudioBucket: "knowtex-real-time-audio-chunks-prod",
  failedJobsTable: "FailedJobs-prod",
  summarizeJobsTable: "SummarizeJobs-prod",
  realtimeAudioChunksTable: "RealTimeAudioChunks-prod",
  evalSummarizeJobsTable: "Eval-SummarizeJobs-prod",
  sentryDsn:
    "https://d6d0b996190fd93051ab517c71c2bbf5@o4506534627377152.ingest.us.sentry.io/4508887598694400",
  sentryReplayBaseUrl: "https://knowtexai.sentry.io/explore/replays",
  sentryIssuesUrl:
    "https://knowtexai.sentry.io/issues/?project=4507862860693504&statsPeriod=7d",
  logRocketUrl:
    "https://app.logrocket.com/b0hpsh/knowtex-prod/sessions?persistForm=true&range=1w&rangeEnd=1722358518688&rangeStart=1721753718688&timeRange=86400000",
  productionDashboardUrl:
    "https://github.com/Knowtex-ai/knowtex-production-dashboard",
  adminDashboardRepositoryUrl:
    "https://github.com/Knowtex-ai/admin-dashboard",
  adminBackendRepositoryUrl:
    "https://github.com/Knowtex-ai/knowtex-admin-backend",
  nativeMobileRepositoryUrl:
    "https://github.com/Knowtex-ai/native-mobile-app",
  webAppRepositoryUrl:
    "https://github.com/Knowtex-ai/Knowtex-webapp",
  cloudWatchQueryId: "77c1491c-ebd5-42ff-9a73-1f18d4d015f2",
  cloudWatchLogGroups: [
    "/aws/lambda/sam-knowtex-prod-ChangeMediaFormatFunction-2TtLeVqhe24g",
    "/aws/lambda/sam-knowtex-prod-MobileAudioProcessorFunction-8JHg5CFXBELH",
    "/aws/lambda/sam-knowtex-prod-RunRegisterAudioChunksFunction-YAcDgtQhLWKj",
    "/aws/lambda/sam-knowtex-prod-RunWhisperRealTimeAudioChunksFunc-RHKXdyAJ7ull",
    "/aws/lambda/sam-knowtex-prod-RunChatgptFunction-QRcgs2lGuWSR",
    "/aws/lambda/sam-knowtex-prod-RunChatgptCodingFunction-LYtqOhTeIjf2",
    "/aws/lambda/sam-knowtex-prod-RunSoapQAFunction-fDHwW7s8TCGs",
    "/aws/lambda/sam-knowtex-prod-RunOnineSoapNoteEvaluationFunctio-XHt1uRxdqOTm",
    "/aws/lambda/sam-knowtex-prod-RunICD10CodingFunction-OcqzGO9xTaVb",
    "/aws/lambda/sam-knowtex-prod-RunICD10CodingV2Function-Dje1Tf2eDOHL",
    "/aws/lambda/sam-knowtex-prod-RunMedicalTestsOrderFunction-rUknPfYQIeSB",
    "/aws/lambda/sam-knowtex-prod-RunSoapNoteTaggingFunction-G2aXmK7K0MFp",
    "/aws/lambda/merge-audios-chunks-prod",
    "/aws/lambda/update-patient-timespent-prod",
    "/aws/lambda/sam-knowtex-prod-RunICD10CodingVAFunction-jJoIq9gHsbY2",
    "/aws/lambda/sam-knowtex-prod-RunEvaluationManagementFunction-SRomLAblJQlQ",
    "/aws/lambda/sam-knowtex-prod-RunOrdersV2Function-lq873IHARcnf",
  ],
};

const csv = (value, fallback) =>
  (value || fallback.join(","))
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

// Keep all CRA environment reads in this module. Direct property access is
// required so react-scripts can substitute values at build time.
export const environment = {
  apiUrl: process.env.REACT_APP_API_URL,
  dynamoApiUrl: process.env.REACT_APP_DYNAMO_API_URL,
  llmApiUrl: process.env.REACT_APP_LLM_API_URL,
  integrationApiUrl: process.env.REACT_APP_INTEGRATION_API_URL,
  awsRegion: process.env.REACT_APP_AWS_REGION || DEFAULTS.awsRegion,
  cognitoRegion: process.env.REACT_APP_REGION || DEFAULTS.awsRegion,
  cognitoUserPoolId:
    process.env.REACT_APP_USER_POOL_ID || DEFAULTS.cognitoUserPoolId,
  cognitoAppClientId:
    process.env.REACT_APP_APP_CLIENT_ID || DEFAULTS.cognitoAppClientId,
  apiGatewayStage:
    process.env.REACT_APP_API_GATEWAY_STAGE || DEFAULTS.apiGatewayStage,
  conversationApiUrl:
    process.env.REACT_APP_CONVERSATION_API_URL ||
    DEFAULTS.conversationApiUrl,
  transcribeJobPrefix:
    process.env.REACT_APP_TRANSCRIBE_JOB_PREFIX ||
    DEFAULTS.transcribeJobPrefix,
  summarizeJobPrefix:
    process.env.REACT_APP_SUMMARIZE_JOB_PREFIX ||
    DEFAULTS.summarizeJobPrefix,
  mobileAudioBucket:
    process.env.REACT_APP_MOBILE_AUDIO_BUCKET || DEFAULTS.mobileAudioBucket,
  mergedAudioBucket:
    process.env.REACT_APP_MERGED_AUDIO_BUCKET || DEFAULTS.mergedAudioBucket,
  realtimeAudioBucket:
    process.env.REACT_APP_REALTIME_AUDIO_BUCKET ||
    DEFAULTS.realtimeAudioBucket,
  failedJobsTable:
    process.env.REACT_APP_FAILED_JOBS_TABLE || DEFAULTS.failedJobsTable,
  summarizeJobsTable:
    process.env.REACT_APP_SUMMARIZE_JOBS_TABLE ||
    DEFAULTS.summarizeJobsTable,
  realtimeAudioChunksTable:
    process.env.REACT_APP_REALTIME_AUDIO_CHUNKS_TABLE ||
    DEFAULTS.realtimeAudioChunksTable,
  evalSummarizeJobsTable:
    process.env.REACT_APP_EVAL_SUMMARIZE_JOBS_TABLE ||
    DEFAULTS.evalSummarizeJobsTable,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || DEFAULTS.sentryDsn,
  sentryReplayBaseUrl:
    process.env.REACT_APP_SENTRY_REPLAY_BASE_URL ||
    DEFAULTS.sentryReplayBaseUrl,
  sentryIssuesUrl:
    process.env.REACT_APP_SENTRY_ISSUES_URL || DEFAULTS.sentryIssuesUrl,
  logRocketUrl:
    process.env.REACT_APP_LOGROCKET_URL || DEFAULTS.logRocketUrl,
  productionDashboardUrl:
    process.env.REACT_APP_PRODUCTION_DASHBOARD_URL ||
    DEFAULTS.productionDashboardUrl,
  adminDashboardRepositoryUrl:
    process.env.REACT_APP_ADMIN_DASHBOARD_REPOSITORY_URL ||
    DEFAULTS.adminDashboardRepositoryUrl,
  adminBackendRepositoryUrl:
    process.env.REACT_APP_ADMIN_BACKEND_REPOSITORY_URL ||
    DEFAULTS.adminBackendRepositoryUrl,
  nativeMobileRepositoryUrl:
    process.env.REACT_APP_NATIVE_MOBILE_REPOSITORY_URL ||
    DEFAULTS.nativeMobileRepositoryUrl,
  webAppRepositoryUrl:
    process.env.REACT_APP_WEB_APP_REPOSITORY_URL ||
    DEFAULTS.webAppRepositoryUrl,
  cloudWatchQueryId:
    process.env.REACT_APP_CLOUDWATCH_QUERY_ID ||
    DEFAULTS.cloudWatchQueryId,
  cloudWatchLogGroups: csv(
    process.env.REACT_APP_CLOUDWATCH_LOG_GROUPS,
    DEFAULTS.cloudWatchLogGroups
  ),
  cloudWatchTraceUrlTemplate:
    process.env.REACT_APP_CLOUDWATCH_TRACE_URL_TEMPLATE,
};

export function joinUrl(baseUrl, ...parts) {
  const base = String(baseUrl || "").replace(/\/+$/, "");
  const path = parts
    .filter((part) => part !== undefined && part !== null && part !== "")
    .map((part) => String(part).replace(/^\/+|\/+$/g, ""))
    .join("/");
  return path ? `${base}/${path}` : base;
}

export function buildApiGatewayUrl(baseUrl, path, stage = environment.apiGatewayStage) {
  const base = String(baseUrl || "").replace(/\/+$/, "");
  const stageSuffix = `/${String(stage).replace(/^\/+|\/+$/g, "")}`;
  return joinUrl(
    base.toLowerCase().endsWith(stageSuffix.toLowerCase())
      ? base
      : joinUrl(base, stage),
    path
  );
}

export function buildDynamoApiUrl(path) {
  return buildApiGatewayUrl(environment.dynamoApiUrl, path);
}

export const dynamoApiBaseUrl = buildDynamoApiUrl("");

export function buildConversationApiUrl(path = "conversation") {
  return buildApiGatewayUrl(environment.conversationApiUrl, path);
}

export function createTranscribeJobName(value) {
  return `${environment.transcribeJobPrefix}${value}`;
}

export function createSummarizeJobName(value) {
  return `${environment.summarizeJobPrefix}${value}`;
}

export function parseTranscribeJobName(jobName, { stripMp3 = false } = {}) {
  if (!jobName?.startsWith(environment.transcribeJobPrefix)) return null;
  const value = jobName.slice(environment.transcribeJobPrefix.length);
  return stripMp3 && value.endsWith(".mp3") ? value.slice(0, -4) : value;
}

export function parseSummarizeJobName(jobName) {
  if (!jobName?.startsWith(environment.summarizeJobPrefix)) return null;
  return jobName.slice(environment.summarizeJobPrefix.length);
}

const encodeCloudWatchFragment = (value) =>
  encodeURIComponent(String(value))
    .replace(/%[0-9A-F]{2}/g, (match) => match.toLowerCase())
    .replace(/%/g, "*");

export function buildCloudWatchTraceUrl(patientId) {
  if (environment.cloudWatchTraceUrlTemplate) {
    return environment.cloudWatchTraceUrlTemplate.replace(
      "{patientId}",
      encodeURIComponent(patientId)
    );
  }

  const sources = environment.cloudWatchLogGroups
    .map((group) => `~'${encodeCloudWatchFragment(group)}`)
    .join("");
  const patient = encodeCloudWatchFragment(patientId);
  return (
    `https://${environment.awsRegion}.console.aws.amazon.com/cloudwatch/home?region=${environment.awsRegion}` +
    "#logsV2:logs-insights$3FqueryDetail$3D~(end~0~start~-3600~timeType~'RELATIVE~tz~'LOCAL~unit~'seconds" +
    "~editorString~'fields*20*40timestamp*2c*20*40message*2c*20*40logStream*2c*20*40log" +
    `*0a*7c*20filter*20*40message*20like*20*2f*3c*3cTRACE_PATIENT_ID*3a*3a${patient}*3e*3e*2f` +
    "*0a*7c*20sort*20*40timestamp*20desc*0a*7c*20limit*2010000" +
    `~queryId~'${environment.cloudWatchQueryId}~source~(${sources})~lang~'CWLI)`
  );
}

export function buildCloudWatchDashboardsUrl() {
  return `https://${environment.awsRegion}.console.aws.amazon.com/cloudwatch/home?region=${environment.awsRegion}#dashboards/`;
}

export function buildSentryReplayUrl(replayId, timeOffsetSeconds) {
  return `${joinUrl(environment.sentryReplayBaseUrl, replayId)}?t=${timeOffsetSeconds}`;
}

